import React from 'react';
import { BudgetInput } from '../../../components/shared/BudgetInput';
import BudgetStepWrapper from './BudgetStepWrapper';

// --- Budget Step 3: Wants ---
const BudgetStep3 = ({ wants, setWants, handleChange, onNext, onPrev }) => (
  <BudgetStepWrapper title="Determine Flexible Liabilities" description="Allocate monthly capital constraints for discretionary channels." onNext={onNext} onPrev={onPrev}>
    <BudgetInput label="Groceries" id="groceries" value={wants.groceries} onChange={v => handleChange(setWants, 'groceries', v)} />
    <BudgetInput label="Restaurants/Takeout" id="restaurants" value={wants.restaurants} onChange={v => handleChange(setWants, 'restaurants', v)} />
    <BudgetInput label="Gas/Transportation" id="gas" value={wants.gas} onChange={v => handleChange(setWants, 'gas', v)} />
    <BudgetInput label="Entertainment & Social" id="entertainment" value={wants.entertainment} onChange={v => handleChange(setWants, 'entertainment', v)} />
    <BudgetInput label="Shopping & Personal Care" id="shopping" value={wants.shopping} onChange={v => handleChange(setWants, 'shopping', v)} />
  </BudgetStepWrapper>
);

export default BudgetStep3;